import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import CTA from './components/CTA';
import Footer from './components/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import { useSEO } from '../../utils/seo';

export default function HomePage() {
  useSEO({
    title: '赤帽みなとサービス | 長崎県の軽運送サービス 引越し・不用品整理・貨物配送',
    description: '長崎県を拠点とした軽運送事業の赤帽みなとサービス。引越し、家具・家電運搬、不用品整理、貨物配送まで地域密着のきめ細やかなサービスを提供。24時間365日対応、即日対応可能。お見積もり無料、明朗会計で安心。',
    keywords: '長崎県,軽運送,引越し,貨物配送,家具運搬,不用品整理,赤帽みなとサービス,赤帽,24時間対応,即日対応',
    canonical: '/',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: '赤帽みなとサービス',
      description: '長崎県を拠点とした軽運送事業。引越しから貨物配送まで、地域密着のきめ細やかなサービスを提供します。24時間365日対応、即日対応可能。',
      telephone: '0120-743-643',
      address: {
        '@type': 'PostalAddress',
        addressRegion: '長崎県',
        addressCountry: 'JP'
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '32.744839',
        longitude: '129.873756'
      },
      openingHoursSpecification: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '00:00',
        closes: '23:59'
      },
      priceRange: '¥¥',
      areaServed: {
        '@type': 'Place',
        name: '長崎県'
      },
      url: import.meta.env.VITE_SITE_URL || 'https://example.com'
    }
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <CTA />
      <Footer />
      <LineFloatingButton />
    </div>
  );
}
